import { useEffect, useState } from 'react'
import axios from 'axios';
import Loading from '../../../component/common/loading/Loading';
import PopupDataGrid from '../../../component/common/popup/PopupDataGrid';
import ExcelDownload from '../../../component/common/button/ExcelDownload';

const BoardModLogList_popup = () => {
    const [data, setData] = useState([{}]);

    const head = ['수정 전', '수정 후', '수정자', '수정일자'];
    const head_column = ['OLDNTTTYP', 'NEWNTTTYP', 'MODID', 'MODDTM'];

    const isSearched = true;

    const sendData = JSON.parse(localStorage.getItem('boardModData'));

    const [loading, setLoading] = useState(false);
    
    const popupData = async () => {
        try {
            const response = await axios.get('/commonapi/boardModLogList.do',
                { params: sendData }
            );
            setData(response.data);
            setLoading(false);
        } catch (e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    }

    useEffect(() => {
        setLoading(true);
        popupData();
    }, []);

    return (
        <div className='popup_font popup_container bg_ho_bg'>
            <div className='flex justify-between items-center'>
                <h4 className='sub_title mb-0'>게시글 분류 수정 이력</h4>
                {/* <button onClick={() => window.close()} className='comm_btn bg_co_black h-7 self-end'>닫기</button> */}
            </div>
            <div className='flex flex-col gap-2 h-full'>
                <div className='flex justify-between items-center'>
                    <span className='total_items'>전체&nbsp;<strong className='ho_color'>{data.length}</strong>건</span>
                    {data.length === 0 ? '' :
                        <div className='btn_container pr-1'>
                            <ExcelDownload excelHead={head} searched={isSearched} excelData={data} dataCode={head_column} excelFileName='게시글 확인자 리스트' />
                        </div>
                    }
                </div>
                {loading ? <Loading /> :
                    <PopupDataGrid
                        dataHead={head}
                        dataColumn={head_column}
                        dataList={data}
                    />
                }
            </div>
        </div>
    )
}

export default BoardModLogList_popup